export enum StatusMessageType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
}
